import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leadcrm-dashboaard',
  templateUrl: './leadcrm-dashboaard.component.html',
  styleUrls: ['./leadcrm-dashboaard.component.css']
})
export class LeadcrmDashboaardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
